import { createGlobalStyle } from 'styled-components';

import { COLORS, FONT_FAMILY, hexWithOpacity } from './style-constants';

const AppGlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  
  html {
    height: 100%;
    font-size: 62.5%; // 1rem = 10px
    animation-timing-function: linear;
    width: 100vw !important;
  }

  body {
    height: 100%;
    padding: 0;
    margin: 0;
    background-color: ${COLORS.pageBackground};
    text-align: left;
    width: 100vw !important;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
  }

  body,
  input,
  textarea,
  button {
    font: 400 1.4rem ${FONT_FAMILY.roboto};
    line-height: 1.6rem;
    color: ${COLORS.textTertiary};
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  @media print {
      html, body, #root {
          height: auto !important;
          overflow: visible !important;
      }

      * {
          overflow: visible !important;
      }
  }
  
  h1, h2, h3, h4, h5, h6 {
  	margin: 0;
  }

  input, textarea, select, button, [role="button"], [contenteditable="true"] {
    outline: none;
    appearance: none;
  }

  :where(a, button, [role="button"], [tabindex]):not(:where(input, textarea, select, [contenteditable="true"], [role="combobox"])):focus-visible {
    outline: 0.2rem solid ${COLORS.purple500};
    outline-offset: 0.3rem;
  }

  input:focus, textarea:focus, select:focus {
    border-color: ${COLORS.inputActiveBorder};
  }

  ::selection {
    background: ${hexWithOpacity(COLORS.purple500, 25)};
    color: ${COLORS.textPrimary};
  }

  input, textarea, select {
    color: ${COLORS.textTertiary};
    accent-color: ${COLORS.accentStrong};
    background-color: ${COLORS.surface};
  }

  ::placeholder {
    color: ${COLORS.textGray};
    opacity: 1;
  }
  
  iframe {
    border: 0;
  }
  
  #root {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    margin: 0 auto;
  }
`;

export default AppGlobalStyle;
